var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAirplaneTakeoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 27H21",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11586 17.5461L6.82778 21.9636C7.45558 22.5521 8.25645 22.9225 9.11147 23.0198C9.9665 23.1171 10.8301 22.936 11.574 22.5034L30.5 11.5L28.1701 8.65233C27.5656 7.91356 26.7169 7.4153 25.7772 7.24754C24.8376 7.07978 23.8689 7.25358 23.0461 7.73754L17.5 11L9.99997 8.5L7.9376 9.38387C7.7833 9.45 7.64813 9.55391 7.54456 9.68601C7.44098 9.81812 7.37233 9.97417 7.34493 10.1398C7.31753 10.3054 7.33226 10.4753 7.38777 10.6337C7.44328 10.7921 7.53777 10.934 7.66255 11.0463L11.5 14.5L7.99997 16.5L4.49997 15L2.40588 15.8975C2.25317 15.9629 2.11917 16.0654 2.01599 16.1956C1.91282 16.3258 1.84371 16.4797 1.81493 16.6434C1.78614 16.807 1.79858 16.9752 1.85112 17.1328C1.90367 17.2905 1.99465 17.4325 2.11586 17.5461V17.5461Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneTakeoff);
export default __webpack_public_path__ + "static/media/AirplaneTakeoff.2d635064d1f6a60c1372590eb48d186b.svg";
export { ForwardRef as ReactComponent };